import { CommonModule, CurrencyPipe } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    numberAttribute,
    Output
} from '@angular/core';
import { CardComponent } from '../card/card.component';
import { SriBannerComponent } from '../sri-banner/sri-banner.component';

@Component({
    selector: 'nw-portfolio-card',
    templateUrl: './portfolio-card.component.html',
    styleUrls: ['./portfolio-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent, CurrencyPipe, CommonModule, SriBannerComponent]
})
export class PortfolioCardComponent {
    @Input() baseCurrency!: string;
    @Input() name!: string;
    @Input() accountId!: string;
    @Input() internalId?: string;
    @Input() portfolioId?: string;
    @Input() type!: string;
    @Input() strategyType!: string;
    @Input() jisa?: Required<{
        firstName: string;
        lastName: string;
        title: string;
    }>;
    @Input({ transform: booleanAttribute }) isDisabled: boolean = false;
    @Input({ transform: numberAttribute }) marketValue!: number;
    @Input({ transform: numberAttribute }) riskLevel!: number;
    @Input({ transform: booleanAttribute }) toggleable: boolean = false;
    @Input({ transform: booleanAttribute }) selected: boolean = false;
    @Input({ transform: booleanAttribute }) showZeroMarketValue: boolean = false;

    @Output() raiseEvent: EventEmitter<Event> = new EventEmitter<Event>();
}
